import { Alert } from './Alert'
import { Text } from '../typography/Text'
import { useTranslations } from '@i18n/useLanguage'
import { Style } from 'inlines'

export type InfoAlertProps = {
  message: string
  style?: Style
}

export const InfoAlert = ({ message, style }: InfoAlertProps) => {
  const t = useTranslations().app.common

  return (
    <Alert variant="info" size="medium" style={style}>
      <Text.Medium style={{ color: 'var(--palette-blue-600)' }}>
        <span style={{fontWeight: 700 }}>{t.note}</span>{' '}
        <span>{message}</span>
      </Text.Medium>
    </Alert>
  )
}
